<template>
    <div>
        <div class="budgeting-tool" v-if="isDoneLoad && isBudgetingActivated">
            <div class="inform_tit">
                <div class='cancel_box'>
                    <span @click="cancel" class="cursor-pointer">
                        <i class="el-icon-back myback_icon"></i> Back
                    </span>
                </div>
            </div>

            <div class="budgeting-tool__content">
                <div class="">
                    <h2 class="budgeting-tool__content--title">Budgeting Chart</h2>
                    <p class="budgeting-tool__content--subtitle">Note: Set your labour target % for each week ending date below.</p>
                </div>

                <div class="budgeting-tool__content--tabs">
                    <div class="tabs-wrapper">
                        <div
                            class="tab-item"
                            :class="{ 'tab-item-active': selectedYear === currentYear }"
                            @click="selectedYear = currentYear"
                        >
                            {{ currentYear }}
                        </div>
                        <div
                            class="tab-item"
                            :class="{ 'tab-item-active': selectedYear === nextYear }"
                            @click="selectedYear = nextYear"
                        >
                            {{ nextYear }}
                        </div>
                    </div>
                </div>

                <div class="budgeting-tool__content--data">
                    <el-row :gutter="5">
                        <el-col v-for="(month, i) in months" :key="i" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                            <div class="budgeting-tool__content--data__month">
                                <h3>{{month}}</h3>
                            </div>
                            <div v-for="(week, i) in displaySelectedWeeks" :key="i" v-show="checkWeekIsInMonth(month, week.week_ending)"  class="budgeting-tool__content--data__item" :class="week.isCurrent ? 'budgeting-tool__content--data__item-active' : ''">
                                <h5>{{ week.week_ending }}</h5>
                                <el-input  type="number" v-model="week.value" :disabled="week.isDisable" @change="changeItem(week, i)" class="budgeting-tool__content--data__item--input">
                                    <template #suffix>
                                        %
                                    </template>
                                </el-input>
                            </div>


                        </el-col>

                    </el-row>
                </div>

                <div class="button-wrapper w-100 d-flex justify-content-center">
                    <el-button v-if="!isLoading" type="peiso-primary-pink-border-only" class="d-flex align-items-center" :disabled="isDisable" @click="saveBudgetingChart()">Save Chart</el-button>
                    <el-button v-else type="peiso-primary-pink-border-only" class="d-flex align-items-center" :disabled="true"><i class="el-icon-loading"></i> Saving...</el-button>

                </div>
            </div>
        </div>

        <div v-if="isDoneLoad && !isBudgetingActivated" class="set-budgeting-tool-container d-flex flex-column">
            <div>
                <div class="error-container d-flex align-items-center justify-content-center">
                    <card-unauthorized></card-unauthorized>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
    .budgeting-tool {
        width: 100%;
        height: auto;

        .el-input.is-disabled .el-input__inner {
            border: none !important;
        }
        &__content {
            background-color: var(--background-color-4);
            width: 100%;
            padding: 50px;
            text-align: center;
            &--title {
                @include pingfang-font(28px, 150%, 500, $white);
                margin-bottom: 10px;
            }

            &--subtitle {
                @include pingfang-font(15px, 150%, 500, $white);
                margin-bottom: 20px;
            }

            &--tabs {
                margin-top: 30px;
                margin-bottom: 20px;
                display: flex;
                justify-content: center;

                .tabs-wrapper {
                    display: flex;
                    gap: 10px;
                    background-color: var(--background-color-3);
                    padding: 5px;
                    border-radius: 10px;

                    .tab-item {
                        @include pingfang-font(15px, 150%, 500, $white);
                        padding: 12px 40px;
                        border-radius: 8px;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        background-color: transparent;

                        &:hover {
                            background-color: rgba(255, 255, 255, 0.1);
                        }

                        &-active {
                            background-color: var(--primary-color);
                            font-weight: 600;
                        }
                    }
                }
            }

            &--data {
                margin-top: 50px;
                margin-bottom: 60px;
                &__item-active {
                    border: 2px solid var(--primary-color) !important;
                }
                &__month {
                    @include pingfang-font(13px, 150%, 400, $white);
                    text-align: center;
                    margin-bottom: 20px;
                    text-transform: capitalize;;
                }
                &__item {
                    width: 100%;
                    padding: 10px 3px;
                    border-radius: 10px;
                    margin-bottom: 5px;
                    background-color: var(--background-color-3) !important;
                    color: var(--text-color);
                    text-align: center;
                    border: 2px solid transparent;
                    h5 {
                        @include pingfang-font(13px, 150%, 400, $white);
                        font-weight: 300 !important;
                    }
                    .el-input.is-disabled .el-input__inner {
                        background-color: transparent !important;
                        color: $white !important;
                    }

                    .el-input.is-disabled .el-input__suffix-inner {
                        color: $white!important;
                    }
                    &--input {
                        margin-top: 5px;
                        position: relative;
                        width: 85px !important;
                        margin-right: 10px;
                        .el-input__inner {
                            @include pingfang-font(15px, 150%, 400, $white);
                            padding: 0px;
                            text-align: center;
                            background-color: transparent;
                            border: none;
                        }

                        .el-input__suffix {
                            display: flex;
                            align-items: center;
                        }
                        .el-input__suffix-inner {
                            @include pingfang-font(15px, 150%, 400, $white) {
                            }
                        }


                    }
                }
            }
        }

        .el-button {
            padding: 15px 30px !important;
        }

    }

    .set-budgeting-tool-container {
        height: calc(100vh - 211px);

        .set-budgeting-tool-wrapper {
            height: 100%;
            background-color: $gray7;
            gap: 1rem;
            position: relative;
            overflow: auto;
            .title {
                @include pingfang-font(28px, 150%, 500, $white) {
                    padding: 0.5rem 0px 2rem;
                }
            }

            .content-wrapper {
                position: relative;
                height: calc(100% - 82px);

                .budgeting-note-container {
                    @include pingfang-font(16px, 150%, normal, $white) {
                        position: absolute;
                        top: -1.7rem;
                        left: 2rem;
                    }
                }
            }

            .chart-container {
                height: 100%;
                width: auto;
                align-content: center;
                overflow: auto;
                .row-wrapper {
                    @include pingfang-font(16px, 150%, 400, $white) {
                        height: 50px;
                        width: 256px;
                        border: 1px solid $gray8;
                        margin: 0px 10px;
                    }

                    .value {
                        width: 140px;
                    }
                }
                .separator {
                    border: 1px solid $gray8;
                }

                .peiso-input-default {
                    height: 100%;
                    .el-input__inner {
                        @include pingfang-font(16px, 150%, 400, $white) {

                            height: 100%;
                            padding: 0px;
                            text-align: center;
                            background-color: transparent;
                            border: none;
                            padding-right: 24px;
                        }

                    }

                    &.el-input--suffix {
                        .el-input__suffix {
                            display: flex;
                            align-items: center;
                        }
                    }
                }

                .dark-bg {
                    background-color: $black2;
                }
            }

            .button-wrapper {
                background-color: $gray7;
                padding: 0.5rem 0px 1rem;
            }

            .el-button {
                &--peiso-primary-pink-border-only {
                    height: 60px;
                    width: 280px;
                }
            }

        }
    }
</style>

<script>
import api from '@/api/api';
import utils from '../../utils/utils';
import cardUnauthorized from '@/components/card/unauthorized';
import moment from 'moment';
    export default {
        data() {
            const currentYear = new Date().getFullYear();
            return {
                weekList: [],
                setWeekList: [],
                checkedData: [],
                monthList: [
                    {id: 0, month: 'January', value: 'jan'},
                    {id: 1, month: 'February', value: 'feb'},
                    {id: 2, month: 'March', value: 'mar'},
                    {id: 3, month: 'April', value: 'apr'},
                    {id: 4, month: 'May', value: 'may'},
                    {id: 5, month: 'June', value: 'jun'},
                    {id: 6, month: 'July', value: 'jul'},
                    {id: 7, month: 'August', value: 'aug'},
                    {id: 8, month: 'September', value: 'sep'},
                    {id: 9, month: 'October', value: 'oct'},
                    {id: 10, month: 'November', value: 'nov'},
                    {id: 11, month: 'December', value: 'dec'},
                 ],
                checkAll: true,
                isLoading: false,
                isBudgetingActivated: false,
                isDoneLoad: false,
                selectedYear: currentYear,
                currentYear: currentYear,
                nextYear: currentYear + 1
            }
        },
        components: {
            cardUnauthorized: cardUnauthorized,
        },
        props: {

        },
        watch: {

        },
        computed: {
            isDisable() {
                var weekList = this.weekList.filter((x) => x.value != '')

                return weekList.length ? false : true
            },

            months() {
                const monthList = this.monthList.map(month => `${month.value} ${this.selectedYear}`);

                return monthList;
            },

            getSelectedMonth() {
                var checkedData = this.checkedData
                var month = []
                checkedData.forEach((data) => {
                    var selected = this.monthList.find((n) => n.value == data)

                    if (selected) {
                        month.push(selected)
                    }

                })

                month = month.sort((a, b) => {
                    return a.id - b.id
                })

                return month
            },

            displaySelectedWeeks() {
                var weeks = []
                this.getSelectedMonth.forEach((n) => {
                    var selected = this.weekList.filter((m) => {
                        return m.week_ending.toLowerCase().includes(n.value) && m.year === this.selectedYear
                    })

                    weeks = [...weeks, ...selected]
                })

                return weeks

            }
        },
        methods: {
            checkWeekIsInMonth (month, date) {
                const originalDate = moment(date, 'DD-MMM-YY');
                const formattedDate = originalDate.format('MMM YYYY');

                return (month === formattedDate.toLowerCase());
            },
            cancel(){
                this.$router.push({path:'/setting'})
            },

            getAllWeekEnding() {
                const currentYear = new Date().getFullYear();
                const nextYear = currentYear + 1;
                const currentWeekNumber = utils.getWeeks(new Date());
                const currentDate = new Date();

                const generateWeeksForYear = (year) => {
                    const weeks = [];

                    // Start from December of previous year to capture weeks that end in this year
                    const startDate = new Date(year - 1, 11, 1); // December 1st of previous year
                    const endDate = new Date(year, 11, 31); // December 31st of this year

                    // Find the first Sunday that falls in or after January 1st of the target year
                    let currentDate = new Date(year, 0, 1);
                    while (currentDate.getDay() !== 0) {
                        currentDate.setDate(currentDate.getDate() + 1);
                    }

                    // If the first Sunday is after Jan 7, we need to include the previous Sunday
                    if (currentDate.getDate() > 7) {
                        currentDate.setDate(currentDate.getDate() - 7);
                    }

                    // Generate weeks for the entire year
                    for (let i = 0; i < 53; i++) {
                        const weekEndDate = new Date(currentDate);
                        weekEndDate.setDate(currentDate.getDate() + (i * 7));

                        // Only include if the week ending falls within the target year
                        if (weekEndDate.getFullYear() === year) {
                            const weekNumber = utils.getWeeks(weekEndDate);
                            const isCurrentYear = year === currentYear;

                            weeks.push({
                                week_ending: utils.getDateFormat(weekEndDate),
                                value: 0,
                                week_ending_date: utils.getDateFormat(weekEndDate, 'YYYY-MM-DD'),
                                week_number: weekNumber,
                                year: year,
                                isDisable: isCurrentYear && weekNumber < currentWeekNumber,
                                isCurrent: isCurrentYear && weekNumber === currentWeekNumber
                            });
                        }

                        // Stop if we've gone past the year
                        if (weekEndDate.getFullYear() > year) {
                            break;
                        }
                    }

                    return weeks;
                };

                // Generate weeks for both current and next year
                const currentYearWeeks = generateWeeksForYear(currentYear);
                const nextYearWeeks = generateWeeksForYear(nextYear);

                this.weekList = [...currentYearWeeks, ...nextYearWeeks];
            },

            changeItem(week, i) {
                week.value = parseFloat(week.value).toFixed(2)
                week.value = parseFloat(week.value) ? parseFloat(week.value) : 0

                if (parseFloat(week.value) > 100) {
                    week.value = 100
                }

                week.value = week.value.toString()

                // Find and update the correct week in the full weekList
                const weekIndex = this.weekList.findIndex(w =>
                    w.week_ending_date === week.week_ending_date && w.year === week.year
                )
                if (weekIndex !== -1) {
                    this.weekList[weekIndex] = week
                }
            },

            saveBudgetingChart() {
                this.isLoading = true
                this.setWeekList = this.weekList
                    .filter((x) => x.value != '')
                    .filter((value, index, self) =>  // remove duplicate week_ending_date
                        index === self.findIndex((t) => t.week_ending_date === value.week_ending_date)
                    )

                api.saveBudgeting({ budgeting: this.setWeekList }).then((res) => {
                    utils.alert2('', 'Successfully saved chart' ,'success');
                    this.isLoading = false
                })
            },
            async getBudgetingTools() {
                const weekList = await api.getBudgetingTools();
                var data = weekList.data

                if (data.code == 0 && data.message == 'Success') {

                    this.weekList = this.weekList.map((n) => {
                        var weekData = data.data.find(m => n.week_ending == m.weekEnding)

                        if (weekData) {
                            n.value = weekData.value
                        }

                        return n
                    })

                }
            },

            getChecked(e) {
                if (this.checkedData.length != 12) {
                    this.checkAll = false
                } else {
                    this.checkAll = true
                }
            },

            checkViewAll() {

                if (this.checkAll) {
                    this.checkedData = [
                        'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
                    ]
                } else {
                    this.checkedData = []
                }
            }
        },
        mounted() {
            this.checkViewAll()
            this.getAllWeekEnding()
            this.getBudgetingTools()

            this.$root.$on('isPro', (isPro, others) => {
                this.isBudgetingActivated = others.isBudgetingActivated
                this.isDoneLoad = true
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/setting/budgetingTool.vue